enum LegalEntityType {
    Individual = "Individual",
    Business = "Business",
}

export default LegalEntityType;